export const userDefaultValuesTranslations = {
  case_type: 3514,
  add: 5783,
  add_default_value_duplicated_values: 8440,
  remove: 5913,
  remove_all_section: 8435,
  save: 8224,
  cancel_changes: 7558,
  are_you_sure: 8218,
  undo_all: 8217,
  go_back: 8219,
  no_options_found: 8220,
  main_title: 8221,
  field: 8018,
  code_table: 8019,
  default_value: 8020,
  default_values: 8021,
  default_value_add_another: 8125,
  default_value_add_new: 8126,
  default_value_add_new_fields: 8127,
  add_default_value_button_text: 8128,
  updated_default_values: 8238,

  role_base_access_custom_button_tab: 8280,
  role_base_access_role_button_tab: 8281,
  
  access_selection_panel_switch_custom_message_first: 8278,
  access_selection_panel_switch_role_based_message_first: 8279,

  access_selection_panel_switch_custom_button: 8276,
  access_selection_panel_switch_role_based_button: 8277,

  validation_error: 8206,
  email_invalid: 7758,
  must_be_equal: 7681,
  must_be_filled: 5949,
  must_be_unique: 8105,
  done: 8288,
  cancel: 7956,

  not_selected: 8236,
  add_default_value_disclaimer: 8275,
  default_value_already_set: 8237,
  search_required_message: 8146,

  select_all: 8420,
  clear_all: 8421
};
